module.exports = __webpack_public_path__ + "static/media/icon-agendamento-rapido.51844e58.png";